module.exports = __webpack_public_path__ + "img/Install-MetaMask.7a7d0dd4.jpg";